import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-comment",
  "use": "icon-comment-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-comment\"><defs><style></style></defs><path d=\"M299.213 451.2a60.8 60.8 0 110-121.6 60.8 60.8 0 010 121.6zm212.787 0a60.8 60.8 0 110-121.6 60.8 60.8 0 010 121.6zm212.813 0a60.8 60.8 0 110-121.6 60.8 60.8 0 010 121.6zm182.4 243.2V116.787H116.762V694.4H268.8v136.806-45.619H25.6V25.6h972.8v760.013H542.387L268.8 998.4V882.867L511.104 694.4h396.109z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol